import { DevelopusTreeTableItemCellType } from '../DevelopusTreeTableCell'

class DevelopusTreeTableCellUIModel {
  constructor(
    text: string | number,
    align?: 'left' | 'center' | 'right',
    width?: number,
  ) {
    this.text = text
    this.align = align
    this.width = width
  }

  private color: string | undefined
  private readonly text: string | number
  private readonly align?: 'left' | 'center' | 'right'
  private readonly width?: number

  setColor(color: string) {
    this.color = color
  }

  toUI(): DevelopusTreeTableItemCellType {
    const text = this.text ? this.text.toString() : ''

    return {
      text: text,
      color: this.color,
      align: this.align ?? 'left',
      width: this.width,
    }
  }
}

export default DevelopusTreeTableCellUIModel
